import { addClass, removeClass } from '../support/classes';

class TextSize
{
    constructor(element, options)
    {
        this.element = element;
        this.options = Object.assign({}, options);

        this.initialize();
    }

    initialize()
    {
        this.bindEvents();
    }

    _handleClick = (e) =>
    {
        const html = document.getElementsByTagName('html')[0];
        const size = e.target.getAttribute('data-size');

        if (!size)
        {
            return;
        }

        const sizes = ['small', 'normal', 'large'];

        for (let i = 0; i < sizes.length; i++)
        {
            if (sizes[i] === size)
            {
                addClass(html, `text-size-${sizes[i]}`);
            }
            else
            {
                removeClass(html, `text-size-${sizes[i]}`);
            }
        }
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
    }
}

export default TextSize;